import { COMPONENT_KEY } from '../constants';

const es = {
  [COMPONENT_KEY]: {
    TITLE_PAGE_ZERO: 'Ocurrió un error',
    DESCRIPTION_PAGE_ZERO: 'Actualiza o inténtalo más tarde.',
    BUTTON_PAGE_ZERO: 'Reintentar',
    TITLE_PAGE_NOT_FOUND: 'Página no encontrada',
    DESCRIPTION_PAGE_NOT_FOUND: 'La página no existe o no ha sido encontrada.',
    BACK: 'Volver',
    TITLE_PAGE_ZERO_NOT_PROCES: '¡Aún no haces parte de ningún proceso!',
    MY_PID: 'Mi PID',
    MY_TEAM: 'Mi equipo',
    PID_TITLE: 'Plan Individual de Desarrollo',
    PID_DESCRIPTION: 'Impulsa tu desarrollo profesional',
    performance: 'Desempeño',
    PID: 'PID',
  },
};

export default es;
